var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    fillOpacity: 0.01
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 14C11.803 14 11.608 13.9612 11.426 13.8858C11.244 13.8104 11.0786 13.6999 10.9393 13.5607C10.8001 13.4214 10.6896 13.256 10.6142 13.074C10.5388 12.892 10.5 12.697 10.5 12.5C10.5 12.303 10.5388 12.108 10.6142 11.926C10.6896 11.744 10.8001 11.5786 10.9393 11.4393C11.0786 11.3001 11.244 11.1896 11.426 11.1142C11.608 11.0388 11.803 11 12 11C12.3978 11 12.7794 11.158 13.0607 11.4393C13.342 11.7206 13.5 12.1022 13.5 12.5C13.5 12.8978 13.342 13.2794 13.0607 13.5607C12.7794 13.842 12.3978 14 12 14ZM7.5 14C7.30302 14 7.10796 13.9612 6.92597 13.8858C6.74399 13.8104 6.57863 13.6999 6.43934 13.5607C6.30005 13.4214 6.18956 13.256 6.11418 13.074C6.0388 12.892 6 12.697 6 12.5C6 12.303 6.0388 12.108 6.11418 11.926C6.18956 11.744 6.30005 11.5786 6.43934 11.4393C6.57863 11.3001 6.74399 11.1896 6.92597 11.1142C7.10796 11.0388 7.30302 11 7.5 11C7.89782 11 8.27936 11.158 8.56066 11.4393C8.84196 11.7206 9 12.1022 9 12.5C9 12.8978 8.84196 13.2794 8.56066 13.5607C8.27936 13.842 7.89782 14 7.5 14ZM16.5 14C16.303 14 16.108 13.9612 15.926 13.8858C15.744 13.8104 15.5786 13.6999 15.4393 13.5607C15.3001 13.4214 15.1896 13.256 15.1142 13.074C15.0388 12.892 15 12.697 15 12.5C15 12.303 15.0388 12.108 15.1142 11.926C15.1896 11.744 15.3001 11.5786 15.4393 11.4393C15.5786 11.3001 15.744 11.1896 15.926 11.1142C16.108 11.0388 16.303 11 16.5 11C16.8978 11 17.2794 11.158 17.5607 11.4393C17.842 11.7206 18 12.1022 18 12.5C18 12.8978 17.842 13.2794 17.5607 13.5607C17.2794 13.842 16.8978 14 16.5 14Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMore);
export default __webpack_public_path__ + "static/media/more.29b24567b5e047fcd77382365e963752.svg";
export { ForwardRef as ReactComponent };